<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="param.fromDate"/> ~ <CustomDatePicker v-model="param.toDate"/></span>
				<item-class-group v-model="param.classGroup" ref="classGroup" />
				<sales-group v-model="param.salesGroupCode" ref="salesGroupCode" />
				<item-class-select-multi-s v-model="param.item_classes" ref="ItemClassSelectMulti" />
				<label>
					<em class="lt_text">Territories</em>
					<span class="mgr_5">
						<select class="int_type" v-model="param.territories">
							<option value="" selected>All</option>
							<option value="D">Domestic</option>
							<option value="O">Overseas</option>
						</select>
					</span>
				</label>
				<label>
					<em class="lt_text">Record</em>
					<span class="int_type_no_border mgr_5">
						<currency-input type="text" v-model="param.record" :precision="0" class="tbl_int ssm_int al_right" />
					</span>
				</label>
				<label>
					<em class="lt_text">Sort</em>
					<span class="mgr_5">
						<select class="int_type" v-model="param.sort">
							<option value="D">DESC</option>
							<option value="A">ASC</option>
						</select>
					</span>
				</label>
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 3%" />
						<col style="width: 5%" />
						<col />
						<col style="width: 15%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
					</colgroup>
					<thead>
						<tr>
							<th>Rank</th>
							<th>Customer Code</th>
							<th>Customer Name</th>
							<th>Address</th>
							<th>City</th>
							<th>State</th>
							<th>Zip</th>
							<th>Phone</th>
							<th>Group</th>
							<th>Group Name</th>
							<th>Sales Amount</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(customer, index) in root" :key="index">
							<td>{{ index + 1 }}</td>
							<td>{{ customer.customer_code }}</td>
							<td>{{ customer.customer_name }}</td>
							<td>{{ customer.address_detail }}</td>
							<td>{{ customer.address_city }}</td>
							<td>{{ customer.address_state }}</td>
							<td>{{ customer.address_zipcode }}</td>
							<td>{{ customer.telephone }}</td>
							<td>{{ customer.salesGroupCode }}</td>
							<td>{{ customer.salesGroupName }}</td>
							<td class="al_right">{{ customer.amount | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="print">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiGetReportTemplate, exportDataExcel, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import { apiSalesTopRecordCustomer } from '@/api/report/report';
import ItemClassGroup from '@/components/common/ItemClassGroup';
import SalesGroup from '@/components/common/SalesGroup';
import { today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			param: {
				classGroup: '',
				salesGroupCode: '',
				fromDate: today(),
				toDate: today(),
				sort: 'D',
				record: 100,
				item_classes: [],
				territories: '',
			},
			root: [],
		};
	},
	components: {
		ItemClassGroup,
		SalesGroup,
		CustomDatePicker,
		ItemClassSelectMultiS,
	},
	computed: {},
	methods: {
		reset() {
			this.$refs.classGroup.reset();
			this.$refs.salesGroupCode.reset();
			this.$refs.ItemClassSelectMulti.reset();
			this.fromDate = today();
			this.toDate = today();
			this.record = 100;
			this.sort = 'A';
		},
		async print() {
			const reportTemplate = await apiGetReportTemplate('SalesTopRecordCustomer', reportMrtUrl('SalesTopRecordCustomer'));
			const report = new Report(reportTemplate, this.root, 'SalesTopRecordCustomer');
			this.$store.commit('setReport', report);
		},
		async search() {
			const param = objectToFormData(this.param);
			const { data } = await apiSalesTopRecordCustomer(param);
			this.root = data;
		},
		async excel() {
			// const reportTemplate = await apiGetReportTemplate('SalesTopRecordCustomer', reportMrtUrl('SalesTopRecordCustomer'));
			// const report = new Report(reportTemplate, this.root, 'SalesTopRecordCustomer');
			// exportFile(report, exportFileType.excel, true);

			const header = [
				{ key: 'customer_code', name: 'Customer Code', width: 15 },
				{ key: 'customer_name', name: 'Customer Name', width: 15 },
				{ key: 'full_address', name: 'Full Address', width: 15 },
				{ key: 'email', name: 'Mail', width: 15 },
				{ key: 'address_detail', name: 'Address', width: 15 },
				{ key: 'address_city', name: 'City', width: 15 },
				{ key: 'address_state', name: 'State', width: 15 },
				{ key: 'address_zipcode', name: 'ZipCode', width: 15 },
				{ key: 'telephone', name: 'Phone', width: 15 },
				{ key: 'salesGroupCode', name: 'Group', width: 15 },
				{ key: 'salesGroupName', name: 'Group Name', width: 15 },
				{ key: 'amount', name: 'Sales Amount', width: 15, dataType: defaultDataType.number },
			];
			exportDataExcel(this.root, header, 'SalesTopRecordCustomer');
		},
	},

	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesTopRecordCustomer');
		this.$store.commit('setSubTitle', 'Report -> Sales Top Record Customer');
	},
	mounted() {},
};
</script>

<style></style>
